import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css`
  .area-note-modal {
    width: 380px;
    padding: 16px;
  }
  .area-note-modal-inputs {
    width: 100%;
    padding-bottom: 16px;
  }
  .area-note-modal-wrapper {
    margin-bottom: 8px;
    height: 250px;
  }
  .area-note-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
    background-color: black;
  }
  .area-note-modal :global(.submit-button:hover) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
    background-color: black;
  }
  .area-note-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .area-note-modal :global(.cancel-button:hover) {
    ${common.button}
    ${common.cancelButton}
  }
  .area-note-title {
    font-size: 14px;
    margin-bottom: 6px;
    font-weight: 600;
  }
  .text-area-wrapper {
    border: 1px solid #676767;
    border-radius: 4px;
    width: 100%;
    height: 120px;
    resize: none;
  }
`;

export default style;
